<template>
  <div class="Fuell-Table--row">
    <div
      class="Fuell-Table--item clickable"
      @click="editFileFormat"
    >{{ fileFormatName }}</div>
    <div
      class="Fuell-Table--item clickable"
      @click="editFileFormat"
    >
      <span class="ellipsis">{{ fileFormatAuthor }}</span>
    </div>
    <div
      class="Fuell-Table--item clickable"
      @click="editFileFormat"
    >{{ fileFormatFormat }}</div>
    <div
      class="Fuell-Table--item clickable"
      @click="editFileFormat"
    >
      <template v-for="(used, index) in fileFormatUsedSlice">
        <div :key="used.id">
          <span> {{used}} </span>
          <span v-if="index !== (fileFormatUsedSlice.length - 1)"> , </span>
        </div>
      </template>
      <span
        v-if="fileFormatUsed && fileFormatUsed.length > 2"
        class="ml-1"
      >{{$t('export_count_used_more', {quantity: fileFormatUsed.length - 2})}}</span>
    </div>
    <div class="Fuell-Table--item Fuell-Table--options">
      <dropdown :closeOnClickInside="false">
        <div
          class="clickable"
          role="button"
          @click="editFileFormat"
        >{{$t('ACTION_EDIT')}}</div>
        <div
          class="clickable"
          role="button"
          @click="handleDeleteFileFormat"
        >{{$t('ACTION_REMOVE')}}</div>
      </dropdown>
    </div>
    <confirm-modal
      v-if="showConfirmModal"
      :open.sync="showConfirmModal"
      :title="'ACTION_REMOVE'"
      :acceptText="'ACTION_REMOVE'"
      @accept="deleteFileFormat"
    ></confirm-modal>
  </div>
</template>

<script>
import Dropdown from '@/components/Commons/Dropdown'
import ConfirmModal from '@/components/Commons/ConfirmModal'

export default {
  name: 'FileFormatTableRow',
  components: { Dropdown, ConfirmModal },
  props: {
    fileFormat: {
      type: Object
    }
  },
  data () {
    return {
      showConfirmModal: false
    }
  },
  computed: {
    fileFormatName () {
      return this.fileFormat.name
    },
    fileFormatAuthor () {
      return `${this.fileFormat.user.firstName} ${this.fileFormat.user.lastName}`
    },
    fileFormatFormat () {
      return this.fileFormat.exportFormat?.code
    },
    fileFormatUsed () {
      return this.fileFormat?.exportSettings?.map(item => item.name)
    },
    fileFormatUsedSlice () {
      return this.fileFormat?.exportSettings?.map(item => item.name).slice(0, 2)
    }
  },
  methods: {
    editFileFormat () {
      this.$emit('editFileFormat', this.fileFormat.id)
    },
    handleDeleteFileFormat () {
      this.showConfirmModal = true
    },
    async deleteFileFormat () {
      this.$emit('removeFileFormat', this.fileFormat.id)
    }
  }
}
</script>
